import { gql } from "@apollo/client";

export const FETCH_SUPPLIER = gql`
  query FETCH_SUPPLIER($id: ID!) {
    factory(id: $id) {
      id
      state
      nickName
      nameEn
      nameCn
      user {
        email
      }
      initialPassword
      supplierClass
      mainProducts

      signedNdaFileUrl
      enablePurchaseOrder
      documentUrls
      certificates

      contactPerson
      phone
      email
      contactAddress
      trackingLabel

      draftData

      odooPartners {
        id
        company
        odooId
      }
    }
  }
`;

export const FETCH_ODOO_VENDOR = gql`
  query FETCH_ODOO_VENDOR($odooPartnerId: Int!, $company: String!) {
    odooVendor(odooPartnerId: $odooPartnerId, company: $company)
  }
`;

export const SAVE_SUPPLIER = gql`
  mutation SAVE_SUPPLIER(
    $id: ID!
    $documentUrls: [String]
    $enablePurchaseOrder: Boolean
    $certificates: String
    $mainProducts: String
  ) {
    saveSupplier(
      id: $id
      documentUrls: $documentUrls
      enablePurchaseOrder: $enablePurchaseOrder
      certificates: $certificates
      mainProducts: $mainProducts
    ) {
      supplier {
        id
        documentUrls
        enablePurchaseOrder
        certificates
        mainProducts
      }
    }
  }
`;
